import { ref, watch, computed } from 'vue-demi';
import { Notifications } from '@or-sdk/notifications';
import orderBy from 'lodash/orderBy';
import uniqBy from 'lodash/uniqBy';

const size = 10;
function useNotifications(token, config, accountId) {
  const notifications = ref([]);
  const offset = ref(0);
  const allLoaded = ref(false);
  const isLoading = ref(false);
  let instance = null;
  watch(token, token => {
    if ((token === null || token === void 0 ? void 0 : token.length) && config.NOTIFICATIONS_API_URL) {
      instance = new Notifications({
        token: token,
        notificationsUrl: config.NOTIFICATIONS_API_URL,
        accountId
      });
    }
  }, {
    immediate: true
  });
  const hasNew = computed(() => {
    return notifications.value.some(x => !x.seen);
  });
  async function fetchNotifications() {
    if (allLoaded.value) {
      return;
    }
    isLoading.value = true;
    const newNotifications = (await (instance === null || instance === void 0 ? void 0 : instance.listNotifications({
      size,
      from: offset.value
    }))) || [];
    offset.value += size;
    pushNotifications(newNotifications);
    if (newNotifications.length < size) {
      allLoaded.value = true;
    }
    isLoading.value = false;
  }
  async function checkNewNotifications() {
    const newNotifications = (await (instance === null || instance === void 0 ? void 0 : instance.listNotifications({
      seen: false,
      size,
      from: 0
    }))) || [];
    pushNotifications(newNotifications);
  }
  async function markAsRead() {
    isLoading.value = true;
    await (instance === null || instance === void 0 ? void 0 : instance.markSeen());
    notifications.value = notifications.value.map(x => ({
      ...x,
      seen: true
    }));
    isLoading.value = false;
  }
  function pushNotifications(newNotifications) {
    // eslint-disable-next-line max-len
    notifications.value = orderBy(uniqBy([...newNotifications, ...notifications.value], 'id'), ['dateCreated'], ['desc']);
  }
  return {
    notifications,
    hasNew,
    allLoaded,
    isLoading,
    fetchNotifications,
    checkNewNotifications,
    markAsRead
  };
}

export { useNotifications as u };
